import { render, staticRenderFns } from "./process.vue?vue&type=template&id=77cab6cd&scoped=true&"
import script from "./process.vue?vue&type=script&lang=js&"
export * from "./process.vue?vue&type=script&lang=js&"
import style0 from "./process.vue?vue&type=style&index=0&id=77cab6cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cab6cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77cab6cd')) {
      api.createRecord('77cab6cd', component.options)
    } else {
      api.reload('77cab6cd', component.options)
    }
    module.hot.accept("./process.vue?vue&type=template&id=77cab6cd&scoped=true&", function () {
      api.rerender('77cab6cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/create/process.vue"
export default component.exports